import React from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer, Alert } from 'antd';
import CompanyProfilePage from '../settings/companyProfile/CompanyProfilePage';

type CompanyProfileDrawerProps = {
  open: boolean;
  onClose: () => void;
  pendingRequestBrandIds: number[];
  profileComplete: boolean;
  handleRequestBrands: (brandIds: number[]) => void;
};

const CompanyProfileDrawer: React.FC<CompanyProfileDrawerProps> = ({
  open,
  onClose,
  pendingRequestBrandIds,
  profileComplete,
  handleRequestBrands,
}) => {
  const { t } = useTranslation();

  const handleDrawerClose = () => {
    if (pendingRequestBrandIds.length > 0) {
      if (profileComplete) {
        handleRequestBrands(pendingRequestBrandIds);
      }
    }
    onClose();
  };

  return (
    <Drawer
      title={t('receiver:completeProfile')}
      open={open}
      onClose={handleDrawerClose}
      width="80%"
      placement="right"
    >
      <div className="overflow-y-hidden">
        <Alert
          message={t('receiver:profileRequired')}
          description={t('receiver:requireCompanyProfile')}
          type="info"
          showIcon
          className="mb-4"
        />
        <CompanyProfilePage />
      </div>
    </Drawer>
  );
};

export default CompanyProfileDrawer;
